<script setup lang="ts">
interface FlashMessageState {
  isVisible: boolean;
  type: 'error'|string,
  message: string,
  timeoutId: NodeJS.Timeout|null;
}

import {ref, reactive, useTemplateRef} from "vue";
import SpamProtectedForm from "./SpamProtectedForm.vue";
import FlashMessage from "./FlashMessage.vue";

const spamProtectedFormComponent = ref<HTMLFormElement>(null);

const emailValidationError = ref<string | null>(null);

const emailInput = useTemplateRef<HTMLInputElement>('emailInput');

const flashMessage = reactive<FlashMessageState>({
  isVisible: false,
  type: "success",
  message: "",
  timeoutId: null,
});

async function onSubmit(event: SubmitEvent): Promise<void> {
  event.preventDefault();

  try {
    const response = await fetch(document.location.href, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
      },
      body: new FormData(spamProtectedFormComponent.value.form),
    });

    const responseBody = await response.json();

    if (response.status == 200 || (response.status === 400 && responseBody.reason)) {
      emailValidationError.value = null;
      showFlashMessage('Votre inscription a été prise en compte. Vérifiez vos emails pour la confirmer.');
      emailInput.value.value = '';

      if ((response.status === 400 && responseBody.reason)) {
        console.debug(`🤖 ${responseBody.reason}`);
      }
    } else {
      emailValidationError.value = responseBody?.errors?.email?.[0] ?? null;
    }
  } catch (error) {
    console.error(error);
    showFlashMessage("Impossible de vous inscrire pour l'instant. Réessayez plus tard ou contactez-nous.");
  }
}

function showFlashMessage(message: string, type: string = 'success') {
  if (flashMessage.timeoutId) {
    clearTimeout(flashMessage.timeoutId);
    flashMessage.timeoutId = null;
  }

  flashMessage.isVisible = true;
  flashMessage.message = message;
  flashMessage.type = type;

  flashMessage.timeoutId = setTimeout(() => {
    flashMessage.isVisible = false;
    flashMessage.timeoutId = null;
  }, 15000);
}
</script>

<template>
  <spam-protected-form @submit="onSubmit" ref="spamProtectedFormComponent">
    <flash-message v-if="flashMessage.isVisible"
                   :type="flashMessage.type"
    >
      {{ flashMessage.message}}
    </flash-message>
    <slot />

    <label class="relative inline-flex flex-col mr-4 my-2">
      Adresse email
      <input class="mt-2 border-2 border-white rounded-lg bg-transparent placeholder:text-gray-400 focus-visible:border-secondary focus-visible:ring-secondary"
             type="email"
             name="email"
             placeholder="jean-denis@example.com"
             required
             ref="emailInput"
      />
      <span v-if="emailValidationError"
            v-text="emailValidationError"
            class="absolute bottom-[-2em] left-0 right-[-4em] text-xs"
      />
    </label>

    <div class="inline-flex flex-col mr-4 my-2">
      <!-- Honeypot field, see SpamProtectedForm.vue -->
      <label for="contact-info-field">Votre nom</label>
      <input id="contact-info-field"
             name="contact-info"
             type="text"
             required
             aria-live="polite"
             autocomplete="name"
      />
    </div>

    <button type="submit" class="cta cta--secondary my-2">M'inscrire</button>
  </spam-protected-form>
</template>

<style scoped lang="scss">

</style>
